
<template>
  <zm-modal
    :title="title"
    :visible="visible"
    size="large"
    @cancel="open(false)"
    :footer="false"
  >
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="供应商">
              <a-input
                disabled
                v-decorator="['supplierName', { rules: [{ required: true }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系人">
              <a-input
                disabled
                v-decorator="['supplierContactName', { rules: [{ required: true }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="联系方式">
              <a-input
                disabled
                v-decorator="['phone', { rules: [{ required: true }] }]"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="询价单价">
              <a-input
                style="width:calc(100% - 20px)"
                disabled
                v-decorator="['inquiryPrice', { rules: [{ required: true }] }]"
              />
              <span style="display:inline-block;width:20px;text-align:right;">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="询价日期">
              <a-date-picker
                style="width: 100%"
                disabled
                v-decorator="['inquiryTime', { rules: [{ required: true }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="关联商机">
              <a-input
                disabled
                v-decorator="['marketName', { rules: [{ required: true }] }]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="附件">
              <zm-preview
                :list="fileList"
                :previewUrl="$sysInfo.previewUrl"
                :baseUrl="$sysInfo.apiRemote"
                :account="$sysInfo.previewAccount"
                :token="$sysInfo.previewToken"
                :jwtToken="$store.state.user.token"
                downloadUrl="/inquiry/product/record/file/"
              ></zm-preview>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </zm-modal>
</template>

<script>
import { mapState } from 'vuex'
import { inquiryRecordDetail } from '@/api/inquiry'
import moment from 'moment'
export default {
  name: 'viewInquiryRecord',
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'inquiry' }),
      visible: false,
      defaultModel: {},
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      colSpan: 12,
      fileList: []
    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.visible = flag
      if (flag) {
        this.setModelInfo()
      } else {
        this.formClear()
      }
    },
    async setModelInfo () {
      const res = await inquiryRecordDetail({ id: this.model.id }).catch(error => {
        console.log('查询失败', error)
        this.$message.error('记录详情查询失败，请稍后重试！')
      })
      const model = res.data
      console.log('model', model)
      this.$nextTick(() => {
        this.form.setFieldsValue({
          supplierName: model.supplierName,
          supplierContactName: model.supplierContactName,
          phone: model.phone,
          inquiryPrice: model.inquiryPrice,
          inquiryTime: moment(model.inquiryTime),
          marketName: model.marketName
        })

        this.fileList = model.files
      })
    },
    // 清空表单
    formClear () {
      this.$nextTick(() => {
        this.model = {}
        this.form.resetFields()
        this.fileList = []
      })
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
  }
}
</script>

<style lang="less">
.info_label{
  margin-bottom: 10px;
}
</style>
